module.exports = __webpack_public_path__ + "img/btn_menu_close.e539146a.svg";